
import Paginate from "vuejs-paginate";

import Vue from "vue";
import ChosenTags from "./components/ChosenTags.vue";
import ChosenDateTags from "./components/ChosenDateTags.vue";
import Filters from "./components/Filters.vue";
import ResultsIndicator from "./components/ResultsIndicator.vue";
import Result from "./components/Result.vue";
import vSelect from "vue-select";
import { SearchAPIModels } from "search-api-client";
import { RenderResources } from "screenmedia-base-index/src/lib/index";

export default Vue.extend({
  name: "SearchIndex",
  props: {
    showkeywords: {
      type: Boolean,
      required: true,
      default: true,
    },
    filtergroupids: {
      type: String,
      required: true,
      default: "",
    },
    filteryear: {
      type: Boolean,
      required: true,
      default: true,
    },
    parentid: {
      type: Number,
      required: true,
      default: -1,
    },
    pagesize: {
      type: Number,
      required: true,
      default: 20,
    },
    title: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      keyword: "" as string,
      keywordInput: "" as string,
      keywordPresent: false as boolean,
      currentPage: 1 as number,
      sortOptions: ["A-Z", "Z-A"] as string[],
      sortOption: "A-Z" as string,
      selectedTags: [],
      selectedYears: [],
      orderBy: "" as string,
      totalPages: Number,
      tags: [] as SearchAPIModels.TaxonomyTag[],
      datetags: [] as SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      toggleFiltersInView: false as boolean,
      index: process.env.VUE_APP_INDEX_NAME,
      apiendpoint: process.env.VUE_APP_BASEURL,
    };
  },
  mounted() {
    this.keywordPresent = this.getQueryVariable("query") !== "";
    this.$data.keyword = this.getQueryVariable("query");
    this.$data.keywordInput = this.getQueryVariable("query");
  },
  computed: {
    firstPage(): number {
      return (this.currentPage - 1) * this.pagesize + 1;
    },
  },
  methods: {
    /*Tag methods*/
    clearAll() {
      this.tags = [];
      this.datetags = [];
      this.updateClear();
    },
    clear(tag: SearchAPIModels.TaxonomyTag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
      this.updateTags(this.tags);
    },
    clearDateTag(tag: SearchAPIModels.GenericSearchResponseFacetsCreatedItem) {
      this.datetags.splice(this.datetags.indexOf(tag), 1);
      this.updateYearTags(this.datetags);
    },
    /******/
    switchFilterOverlay(on: boolean) {
      this.toggleFiltersInView = on;
    },
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1].replace(/\+/g, " ");
        }
      }
      return "";
    },
    lastPage(total: number): number {
      return this.currentPage * this.pagesize > total
        ? total
        : this.currentPage * this.pagesize;
    },
    calculateTotalPages(total: number): number {
      return Math.ceil(total / this.pagesize);
    },
    paginationClick(page: number) {
      const elmnt = document.getElementById("resultsTopSearch");
      if (elmnt) {
        elmnt.scrollIntoView();
      }

      this.$data.currentPage = page;
    },
    convertTagtoSearchTag(
      tag: SearchAPIModels.TaxonomyTag
    ): SearchAPIModels.GenericSearchRequestTaxonomyItem {
      const response: SearchAPIModels.GenericSearchRequestTaxonomyItem = {
        tagId: tag.id,
        categoryId: tag.categoryId,
      };
      return response;
    },
    updateTags(tags: SearchAPIModels.TaxonomyTag[]) {
      this.$data.currentPage = 1;
      this.$data.selectedTags = tags.map((x) => this.convertTagtoSearchTag(x));
    },
    updateClear() {
      this.$data.currentPage = 1;
      this.$data.selectedTags = [];
    },
    updateYearTags(
      tags: SearchAPIModels.GenericSearchResponseFacetsCreatedItem[]
    ) {
      this.$data.currentPage = 1;
      this.$data.selectedYears = tags.map((x) => x.value?.getFullYear());
    },
    updateYearClear() {
      this.$data.keyword = "";
      this.$data.keywordInput = "";
      this.$data.currentPage = 1;
      this.$data.selectedYears = [];
    },
    updateKeyword() {
      this.$data.keywordInput = this.$data.keyword;
    },
    clearKeyword() {
      this.$data.keywordInput = "";
      this.$data.keyword = "";
    },
    resourcesChanged(update: SearchAPIModels.AzureSearchResponse) {
      const total = update.count !== undefined ? update.count : 0;
      this.$data.totalPages = this.calculateTotalPages(total);
    },
  },

  components: {
    Filters,
    ResultsIndicator,
    Result,
    Paginate,
    RenderResources,
    ChosenTags,
    ChosenDateTags,
  },
});
